import React from 'react';
import { Box } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import Divider from '@/components/Divider';
import Inclusion from '@/components/Inclusion';
import Text from '@/components/Text';
import InclusionPropTypes from '@/propTypes/Inclusion';

const DealInclusions = ({
  inclusions = [],
  title = 'Package inclusions',
  shownInclusions = 4,
  showDivider = false,
  hideSubtitle = false,
}) => (
  <>
    <Box mb={2}>
      <Text bold fontSize={['xs', null, 'sm']}>
        {title}
      </Text>
    </Box>
    <Box>
      {inclusions.slice(0, shownInclusions)?.map((inclusion, i) => (
        <>
          <Box key={inclusion.code} mr="5" mb="2">
            <Inclusion
              inclusion={inclusion}
              hideSubtitle={hideSubtitle}
              isLastShownInclusion={
                i === shownInclusions - 1 && shownInclusions < inclusions.length
              }
            />
          </Box>
          {showDivider && <Divider />}
        </>
      ))}
    </Box>
  </>
);

DealInclusions.propTypes = {
  inclusions: PropTypes.arrayOf(PropTypes.shape(InclusionPropTypes)).isRequired,
  hideSubtitle: PropTypes.bool,
  showDivider: PropTypes.bool,
  title: PropTypes.string,
  shownInclusions: PropTypes.number,
};

export default DealInclusions;
